import { Outlet } from "react-router-dom";
import React from "react";
import SideBar from "../pages/me/components/sidebar";
import {Helmet} from 'react-helmet'
import MobileNav from "../pages/me/components/MobileNav";
import { useTranslation } from "react-i18next";
function ProfileLayout() {
  const {t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  return (
    <>
      <Helmet>
        ‍<title>حسابي - محصول</title>‍
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool" />
        <meta property="og:title" content="حسابي - محصول" />
        <meta property="og:description" content="mahsool" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="flex flex-col lg:flex-row justify-between w-screen h-auto relative">
        <div className="lg:hidden">
          <MobileNav />
        </div>
        <div className="lg:w-[83%] overflow-x-hidden  h-auto">
          <Outlet />
        </div>
        <div className={`overflow-x-hidden overflow-y-auto invisible lg:visible fixed w-full lg:w-auto lg:px-0 px-4 ${isRTL ? 'left-0 lg:left-4' : 'right-0 lg:right-4'}`}>
          <SideBar />
        </div>
      </div>
    </>
  );
}

export default ProfileLayout;
